<div class="invalid-qr-container">
  <app-mobile-header [title]=" locDesc ? locDesc : 'label.qr.expired'" [isShowBackButton]="false"></app-mobile-header>

  <div class="invalid-qr-content">
    <img [src]="storeImageUrl | storeImage" alt="image" loading="lazy">

    <div class="invalid-qr-des-content">
      <h1 class="qrExpired-title">{{ 'label.qr.expired' | translate}}</h1>
      <span>{{'desc.qr.expired.request.new.code.to.start.order' | translate}}</span>
    </div>

    <app-button [textButton]="true" [iconName]="'icon-scan'" [buttonName]="'button.scan.qr'"
      (click)="onClickScan()"></app-button>
  </div>
</div>